

import HomeComponent from "./components";

export default HomeComponent;